import { render, staticRenderFns } from "./WorkReportsProfessorComments.vue?vue&type=template&id=4b0c47d2"
import script from "./WorkReportsProfessorComments.vue?vue&type=script&lang=js"
export * from "./WorkReportsProfessorComments.vue?vue&type=script&lang=js"
import style0 from "./WorkReportsProfessorComments.vue?vue&type=style&index=0&id=4b0c47d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_babel-core@6.26.3_css-loader@6.11.0_webpack_7df808e90dc1ecdae917673cdf41e242/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports